export const LEGEARTIS_HOST_MATCHES = ['legeartis','lgas'];
